import { render, staticRenderFns } from "./MemberOrder.vue?vue&type=template&id=2ba0bab4&scoped=true"
import script from "./MemberOrder.vue?vue&type=script&lang=js"
export * from "./MemberOrder.vue?vue&type=script&lang=js"
import style0 from "./MemberOrder.vue?vue&type=style&index=0&id=2ba0bab4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0bab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba0bab4')) {
      api.createRecord('2ba0bab4', component.options)
    } else {
      api.reload('2ba0bab4', component.options)
    }
    module.hot.accept("./MemberOrder.vue?vue&type=template&id=2ba0bab4&scoped=true", function () {
      api.rerender('2ba0bab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/components/MemberOrder.vue"
export default component.exports